'use client';

import { SERVICE, useDeviceInfo } from '@musinsa/packages-device-detection';
import { track } from '@musinsa/packages-event-snowplow';
import { useQuery } from '@tanstack/react-query';
import { curatorQueries } from '../../query-factory';
import { SNOWPLOW_SCHEME } from '../../snowplow';
import { CampaignDiscountItem } from './CampaignDiscountItem';

export const CampaignDiscountGroup = () => {
  const { data: mypageData } = useQuery(curatorQueries.mypage.data());
  const { service } = useDeviceInfo();

  const campaignLinks = mypageData?.campaignLinks || [];

  if (campaignLinks.length === 0) {
    return null;
  }

  const handleClickItem = (title: string) => {
    if (service === SERVICE['29CM']) {
      track({
        schema: SNOWPLOW_SCHEME.CLICK_BUTTON,
        data: {
          page_name: 'curator_mypage',
          section_name: 'Promotion',
          section_title: '캠페인&할인상품 정보',
          position: 6,
          button_id: 'enter_page',
          button_name: title,
        },
      });
    }
  };

  return (
    <div className="flex flex-col">
      {campaignLinks.map((item, index) => (
        <CampaignDiscountItem
          key={`${item.url}-${index}`}
          href={item.url}
          text={item.title}
          onClick={() => handleClickItem(item.title)}
        />
      ))}
    </div>
  );
};
